import React from "react";

const GuestUser = () => {
  return <div>GuestUser</div>;
};

export default GuestUser;
